import { createFileRoute } from "@tanstack/react-router";
import { DevicePage } from "../features/settings/device-page";

export const Route = createFileRoute("/more/device")({ component: DevicePage });
